import { Component, OnInit } from '@angular/core';
import { Utils } from 'src/app/common/utils';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormControl } from '@angular/forms';
import { VproService } from 'src/app/service/vpro/vpro.service';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { CouponDetails } from 'src/app/models/CouponDetails';
import moment from 'moment';

const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});


@Component({
  selector: 'app-coupons-search',
  templateUrl: './coupons-search.component.html',
  styleUrls: ['./coupons-search.component.css']
})
export class CouponsSearchComponent implements OnInit {

  constructor(
    private _formBuilder: UntypedFormBuilder,
    private service: VproService,
    private spinner: NgxSpinnerService,
    private utils: Utils,
  ) { }

  couponSearchForm: UntypedFormGroup;
  couponData: any = [];
  allCouponDetails: CouponDetails[];

  ngOnInit() {
    this.couponSearchForm = this._formBuilder.group({
      coupon_id: ['']
    })
  }

  showToast(type, title) {
    Toast.fire({
      type: type,
      title:
        title
    });
  }

  findCoupon() {
    let queryParam: string = "";
    if (this.couponSearchForm.value.coupon_id != "") {
      queryParam = `?id=${this.couponSearchForm.value.coupon_id}`;
    }
    this.spinner.show();
    this.service.fetchCoupons(queryParam).subscribe(res => {
      this.spinner.hide();
      this.allCouponDetails = res;
    }, err => {
      // console.log(err);
      this.spinner.hide();
      this.showToast('error', "No Coupons Added");
    })
  }

  onCouponStatusChange = async (index, enable) => {
    let data = { active: !enable };
    this.updateCouponStatus(this.allCouponDetails[index].id, data);
  }

  updateCouponStatus(id, data) {
    this.spinner.show();
    this.service.updateCoupons(id, data).subscribe(
      (res) => {
        this.spinner.hide();
        // SweetAlert
        this.showToast('success', "Coupon has been updated successfuly");
        this.findCoupon();
      },
      (error) => {
        this.spinner.hide();
        let message;
        if (error && error.error && error.error.message && error.error.message.message) {
          message = error.error.message.message;
        }
        else message = "Something went wrong. Couldn't update Coupon."
        this.showToast('error', message);
        this.findCoupon();
      }
    );
  }

  expiryCheck(index) {
    let validTo = moment.utc(this.allCouponDetails[index].valid_to);
    return validTo.isBefore(moment().utc());
  }

}
